import { FieldValues, Path, UseFormSetError } from "react-hook-form";

import { ValidationError } from "../api/courses-users.generated";

export interface ApiError {
  status?: number;
  data?: {
    code?: number;
    data?: ValidationError[];
    message?: string;
  };
}

export interface ValidationErrorResult {
  hasFieldErrors: boolean;
  hasGeneralError: boolean;
  errorMessage?: string;
}

export function handleValidationErrors<T extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<T>
): ValidationErrorResult {
  const apiError = error as ApiError;

  if (
    apiError?.data?.data &&
    Array.isArray(apiError.data.data) &&
    apiError.data.data.length > 0
  ) {
    apiError.data.data.forEach((validationError: ValidationError) => {
      if (validationError.field && validationError.message) {
        setError(validationError.field as Path<T>, {
          type: "server",
          message: validationError.message,
        });
      }
    });

    return {
      hasFieldErrors: true,
      hasGeneralError: false,
    };
  }

  return {
    hasFieldErrors: false,
    hasGeneralError: !!apiError?.data?.message,
    errorMessage: apiError?.data?.message,
  };
}
